import { render, staticRenderFns } from "./SetPasswordFromToken.vue?vue&type=template&id=b83fc342&"
import script from "./SetPasswordFromToken.vue?vue&type=script&lang=js&"
export * from "./SetPasswordFromToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports